<template>
  <li class="text-button-xs font-button py-2.5">
    <slot />
  </li>
</template>
